(function(){

  var linkFunction = function ($scope, element, attrs){
      // console.log("Billing Address Selection Link Func: ", $scope, element, attrs);
  }

  var controllerFunction = function($scope, UserSession){
      // console.log("Billing Address Selection Controller Func: ", $scope);
      // $scope.primaryAddress = UserSession.accountData.primaryAddress;
      // $scope.newAddress = {};
      // TODO: Currently just checking if the "Other" address has
      // a 'truthy' value for addressLine1. Might be safer way to determine this
      $scope.provideOptions = UserSession.registered && $scope.other && !$scope.other.addressLine1;
      $scope.selection = $scope.other && $scope.other.addressLine1 ? "other" : "primary";
      $scope.wcmContent = wcmContent;
  }

  var directiveFunction = function(){
      return {
        restrict: 'E',
        templateUrl: '../payments/app/components/billingAddressSelection/billingAddressSelection.template.html',
        controller: controllerFunction,
        link: linkFunction,
        scope:{
          primary:"=",
          other:"=",
          card: "="
        }
      }
  }


  controllerFunction.$inject = ["$scope", "userSession"];
  angular.module('cvsApp').directive('billingAddressSelection', directiveFunction);

})();
